import { useEffect, useState } from 'react'

/** The phone layout: `theme.breakpoints.down('sm')`, the breakpoint of the tab's sass and of `Modal isSheetOnPhone` */
export const PHONE_QUERY = '(max-width: 599.95px)'
/** Narrower than most phones (prototype v3: under 360px the editor's bar drops its glyphs) */
export const NARROW_PHONE_QUERY = '(max-width: 359.95px)'
export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)'

const matches = (query: string) => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches

/** Whether a media query matches now, following its changes; false where `matchMedia` does not exist (jsdom). */
export function useMatchMedia(query: string) {
  const [matched, setMatched] = useState(() => matches(query))

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    const list = window.matchMedia(query)
    const onChange = () => setMatched(list.matches)
    onChange()
    list.addEventListener?.('change', onChange)
    return () => list.removeEventListener?.('change', onChange)
  }, [query])

  return matched
}

/** Read once, where a hook cannot be (an event handler) */
export const matchesNow = matches
